<div class="d-flex flex-column" data-uiid="new-eff-step-header">
    <div class="top-header-section d-flex flex-row justify-content-between">
        <span class="h1-title" data-uiid="new-eff-step-header-title">{{ title }}</span>
        <eff-button
            class="align-self-end link-button"
            icon="info_outlined"
            size="medium-size"
            [text]="'effStepHeader.instructions' | t"
            (onClick)="clickInstructions()"
            data-uiid="new-eff-step-header-instructions-button"
        ></eff-button>
    </div>
    <div class="bottom-header-section d-flex flex-row align-items-center">
        @if (!hideSaveButton) {
            <eff-save-button
                [text]="saveButtonLabel"
                (click)="onSave()"
                data-uiid="new-eff-step-header-save-button"
            >
            </eff-save-button>
        }
        @if (controlInfo) {
            <div
                class="d-flex flex-column control-description-container"
                data-uiid="new-eff-step-header-control-information"
            >
                <span class="control-label bold-text">{{ 'effStepHeader.controlName' | t }}</span>
                <span class="regular-text" data-uiid="new-eff-step-header-control-name">{{
                    controlInfo.ControlName
                }}</span>
            </div>
        }
    </div>
    @if (showNonOccurrenceWarningArea) {
        <div class="warning-area" data-uiid="new-eff-step-header-warning-area">
            <h2 class="h2-title">{{ 'effStepHeader.controlDidntOccur' | t }}</h2>
                <ul>
                    <li>{{ 'effStepHeader.controlDidntOccurDescription' | t }}</li>
                </ul>
        </div>
    }
</div>
